export const generatePriceOptions = (
  start,
  second = 0,
  third = 0,
  end,
  increment
) => {
  let priceRange = [start];

  // Only add second and third if they are not 0
  if (second !== 0) priceRange.push(second);
  if (third !== 0) priceRange.push(third);

  // Start incrementing from the last value in the array (or start + increment if no second/third values are present)
  let current = priceRange[priceRange.length - 1] + increment;

  // Continue adding values until we reach the end
  while (current <= end) {
    priceRange.push(current);
    current += increment;
  }

  return priceRange;
};

export default generatePriceOptions;
